import { getToken } from "../auth.service"
import { getImpersonationUID } from "../../plugins/impersonation"
import { isProduction } from "../../utils/enviroment.utils"

function _getTimeTravelHeader() {
  if (window.__timeMachineBackendTime) {
    return { "x-time-traveled-to": window.__timeMachineBackendTime }
  }
  return {}
}

async function _getAuthorizationHeader() {
  const impersonationUID = isProduction() ? null : getImpersonationUID()
  if (impersonationUID) {
    return { Authorization: `UID ${impersonationUID}` }
  }

  const token = await getToken()
  return { Authorization: `Bearer ${token}` }
}

async function _getRequestConfig(data) {
  const authHeader = await _getAuthorizationHeader()
  if (data instanceof FormData) {
    return {
      headers: {
        ...authHeader,
        "bypass-tunnel-reminder": "true",
        ..._getTimeTravelHeader(),
      },
      body: data,
    }
  }
  return {
    headers: {
      "Content-Type": "application/json",
      "bypass-tunnel-reminder": "true",
      ...authHeader,
      ..._getTimeTravelHeader(),
    },
    body: JSON.stringify(data),
  }
}

export async function get(url, params, config = {}) {
  const authHeader = await _getAuthorizationHeader()
  const BASE_CONFIG = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader,
      "bypass-tunnel-reminder": "true",
      ..._getTimeTravelHeader(),
    },
  }

  const apiUrl = new URL(url)
  apiUrl.search = new URLSearchParams(params || undefined).toString()

  return fetch(apiUrl, { ...BASE_CONFIG, ...config })
}

/** @type {import("./api.service.types.d.ts")["post"]} */
export async function post(url, body, config = {}) {
  const requestConfig = {
    method: "POST",
    ...(await _getRequestConfig(body)),
    ...config,
  }

  return fetch(url, requestConfig)
}

export async function patch(url, body, config = {}) {
  const requestConfig = {
    method: "PATCH",
    ...(await _getRequestConfig(body)),
    ...config,
  }

  return fetch(url, requestConfig)
}

export async function put(url, body, config = {}) {
  const requestConfig = {
    method: "PUT",
    ...(await _getRequestConfig(body)),
    ...config,
  }

  return fetch(url, requestConfig)
}

export async function del(url, body, config = {}) {
  const requestConfig = {
    method: "DELETE",
    ...(await _getRequestConfig(body)),
    ...config,
  }

  return fetch(url, requestConfig)
}

export const api = {
  get,
  post,
  put,
  delete: del,
  patch,
}
